module.exports = __webpack_public_path__ + "assets/54.jpg?d19b518787fe6e8bd83ce2de827fa34b";